export const HIGHEST_POINTS_GAINER_BADGE = 'badges/ribbon.png'
export const FIRST_LESSON_ACHEIVER_BADGE = 'badges/first-ribbon.png'
export const EXTRAORDINARY_BADGE = 'badges/extraordinary.png'
export const LESSON_COMPLETED_BADGE = 'badges/completed.png'
export const POINT_ICON = 'CircleIcon'
